<script setup>
import { ElNotification } from "element-plus";
import { ref } from "vue";

const name = ref("");
const email = ref("");
const message = ref("");

const contact = async () => {
  try {
    const res = await fetch("https://gold-charge.com/api/contact-us", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name.value,
        email: email.value,
        message: message.value,
        surname: "-",
        phone: "1234567890",
        topic: "-",
        telegram: "@123456789q",
      }),
    });

    if (!res.ok) {
      throw new Error("Ошибка при отправке");
    }

    ElNotification({
      title: "Success",
      message: "Your message has been sent!",
      type: "success",
    });

    name.value = "";
    email.value = "";
    message.value = "";
  } catch (error) {
    ElNotification({
      title: "Error",
      message: "Failed to send message",
      type: "error",
    });
  }
};
</script>

<template>
  <div class="contact" id="contact">
    <img src="@images/contact-bg.png" alt="" class="img" />
    <div class="container">
      <div class="contact__wrapper">
        <h2>Ready to Supercharge Your Payments?</h2>
        <div class="contact__wrapper__content">
          <div class="contact__wrapper__content__left">
            <h3>Join the growing network of businesses that trust Gold-Charge.</h3>
            <div class="contact__wrapper__content__left-address">
              <p>
                Email:
                <a href="mailto:info@gold-charge.com">info@gold-charge.com</a>
              </p>
              <p>
                Address:
                <span
                >Suite 28, Wolverhampton, 84 Salop str., WV3 0SR, England</span
                >
              </p>
            </div>
          </div>
          <div class="contact__wrapper__content__right">
            <form @submit.prevent="contact">
              <div>
                <input type="text" placeholder="Name" v-model="name" />
                <input type="text" placeholder="Email" v-model="email" />
              </div>
              <div>
                <textarea placeholder="Message" v-model="message" />
                <button type="submit">Send</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
h2 {
  color: #46302e;
  font-family: "Libre Caslon Text", sans-serif;
  font-size: 36px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
  text-align: center;
}

h3,
a,
span {
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

p {
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

input {
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 0 15.8px 0 rgba(70, 48, 46, 0.26);
  padding: 11px 0 11px 15px;
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 20px;
  width: 100%;

  &::placeholder {
    color: #46302e;
    font-family: "Didact Gothic", sans-serif;
  }
}

textarea {
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 0 15.8px 0 rgba(70, 48, 46, 0.26);
  padding: 11px 0 0 15px;
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 20px;
  resize: none;
  width: 675px;
  height: 180px;
  flex-shrink: 0;

  &::placeholder {
    color: #46302e;
  }
}

button {
  border-radius: 500px 5px 5px 500px;
  background: radial-gradient(
          61.92% 93.12% at 50.52% 21.11%,
          #fceed9 0%,
          #e4b588 100%
  );
  box-shadow: -3px -5px 15px 0 #bca38a inset;
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 10px 60px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background: radial-gradient(
            61.92% 93.12% at 50.52% 21.11%,
            #e4b588 0%,
            #cfa075 100%
    );
  }
}

div {
  position: relative;
}

.img {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.contact {
  padding-block: 80px;
  position: relative;

  &__wrapper {
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 30px;

    &__content {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      gap: 130px;

      &__left {
        display: flex;
        flex-direction: column;
        gap: 30px;

        &-address {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
      }

      &__right form {
        display: flex;
        flex-direction: column;
        gap: 17px;

        & > div {
          display: flex;
          gap: 15px;
        }
      }
    }
  }
}

/* ——— АДАПТИВ ——— */

@media (max-width: 1200px) {
  textarea {
    width: 100%;
  }
}

@media (max-width: 1024px) {
  .contact__wrapper__content {
    flex-direction: column;
    align-items: center;
    gap: 50px;
  }

  .contact__wrapper__content__left {
    text-align: center;
    align-items: center;

    p {
      font-size: 20px;
    }
  }

  form > div {
    flex-direction: column;
  }

  textarea {
    width: 100%;
  }

  button {
    position: relative;
    margin-top: 10px;
    border-radius: 10px;
    width: 100%;
  }
}

@media (max-width: 768px) {

  .contact__wrapper__content__right{
    width: 100%;
  }
  h2 {
    font-size: 28px;
  }

  h3 {
    font-size: 20px;
  }

  p {
    font-size: 18px;
  }

  input,
  textarea {
    font-size: 18px;
  }

  button {
    font-size: 18px;
    padding: 10px 40px;
  }
}

@media (max-width: 480px) {
  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 18px;
  }

  p {
    font-size: 16px;
  }

  input,
  textarea {
    font-size: 16px;
  }

  button {
    font-size: 16px;
    padding: 10px 20px;
  }
}
</style>
